'use strict';

var TileFooterView = Marionette.ItemView.extend({
    template: require('components/dashboard/templates/tile_footer'),
    className: 'tile-footer',

    events: function () {
        var events = {};
        _.each(
            _.union(this.options.leftButtons, this.options.centerButtons, this.options.rightButtons),
            function (button) {
                // add the view id to make the ids unique over the whole dashboard
                button.id += '-' + this.cid;
                events['click #' + button.id] = 'handleAction';
            },
            this
        );
        return events;
    },

    serializeData: function () {
        return this.options;
    },

    handleAction: function (e) {
        var actionType = e.currentTarget.id;
        this.triggerMethod('footer:action', actionType);
    },
});

module.exports = TileFooterView;
